function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import { generateCodeVerifier, generateCodeChallenge } from './pkce';
import { isVSCodeEnvironment } from './navigation';
import { createDPoPHeaders, isDPoPSupported } from './dpop';
// --- Constants ---
var PKCE_CODE_VERIFIER_KEY = 'pkce_code_verifier';
// --- Helper Variables ---
var silentRefreshIframe = null;
var silentRefreshTimeout = null;
var silentRefreshPromise = null;
// --- Cleanup Function ---
var cleanupSilentRefreshPKCE = function() {
    console.log('[SilentRefreshHandler] Cleaning up PKCE silent refresh resources.');
    if (silentRefreshIframe) {
        try {
            document.body.removeChild(silentRefreshIframe);
        } catch (e) {
            console.warn("Error removing iframe during cleanup:", e);
        }
        silentRefreshIframe = null;
    }
    if (silentRefreshTimeout) {
        clearTimeout(silentRefreshTimeout);
        silentRefreshTimeout = null;
    }
    sessionStorage.removeItem(PKCE_CODE_VERIFIER_KEY);
    silentRefreshPromise = null; // Clear the promise reference
};
// --- Main PKCE Silent Refresh Handler ---
export var handleSilentRefreshPKCE = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(authServerUrl, silentRedirectUri) {
        var isVSCode, clientId, AUTHORIZATION_ENDPOINT, TOKEN_ENDPOINT, SILENT_REDIRECT_URI, baseScope, finalScope;
        return _ts_generator(this, function(_state) {
            console.log('[SilentRefreshHandler] PKCE silentRefresh 시도...');
            isVSCode = isVSCodeEnvironment(); // 환경 확인은 한 번만
            clientId = isVSCode ? 'app-client' : 'web-client';
            console.log("[SilentRefreshHandler] Using Client ID: ".concat(clientId));
            AUTHORIZATION_ENDPOINT = "".concat(authServerUrl, "/oauth2/authorize");
            TOKEN_ENDPOINT = "".concat(authServerUrl, "/oauth2/token");
            SILENT_REDIRECT_URI = silentRedirectUri || "".concat(window.location.origin, "/silent-refresh.html");
            // 동적 Scope 결정
            baseScope = 'openid profile email api.read';
            finalScope = isVSCode ? "".concat(baseScope, " offline_access") // VSCode(app-client): offline_access 포함
             : baseScope; // Browser(web-client): offline_access 제외
            console.log("[SilentRefreshHandler] Using Scope: ".concat(finalScope));
            return [
                2,
                new Promise(function(resolve, reject) {
                    if (silentRefreshPromise) {
                        console.warn('[SilentRefreshHandler] 이미 PKCE silentRefresh 진행 중');
                        return reject(new Error('PKCE Silent refresh already in progress'));
                    }
                    silentRefreshPromise = {
                        resolve: resolve,
                        reject: reject
                    };
                    var codeVerifier = generateCodeVerifier();
                    sessionStorage.setItem(PKCE_CODE_VERIFIER_KEY, codeVerifier);
                    generateCodeChallenge(codeVerifier).then(function(codeChallenge) {
                        var state = Math.random().toString(36).substring(2);
                        var authUrl = new URL(AUTHORIZATION_ENDPOINT);
                        authUrl.searchParams.append('response_type', 'code');
                        authUrl.searchParams.append('client_id', clientId);
                        authUrl.searchParams.append('scope', finalScope);
                        authUrl.searchParams.append('redirect_uri', SILENT_REDIRECT_URI);
                        authUrl.searchParams.append('state', state);
                        authUrl.searchParams.append('prompt', 'none');
                        authUrl.searchParams.append('code_challenge', codeChallenge);
                        authUrl.searchParams.append('code_challenge_method', 'S256');
                        console.log('[SilentRefreshHandler] Silent refresh URL:', authUrl.toString());
                        var iframe = document.createElement('iframe');
                        iframe.style.display = 'none';
                        iframe.src = authUrl.toString();
                        iframe.id = 'silent-refresh-iframe-pkce';
                        silentRefreshIframe = iframe;
                        document.body.appendChild(iframe);
                        // --- Message Handler ---
                        var handleMessage = /*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(event) {
                                var _event_data, _event_data1, code, _$error, errorDescription, result, storedVerifier, tokenParams, dpopSupported, headers, error, tokenResponse, _tokenResponse_data, access_token, refresh_token, expires_in, token_type, tokenError, _tokenError_response, failResult;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (event.origin !== window.location.origin || event.source !== iframe.contentWindow || ((_event_data = event.data) === null || _event_data === void 0 ? void 0 : _event_data.source) !== 'silent-refresh-redirect') {
                                                return [
                                                    2
                                                ];
                                            }
                                            window.removeEventListener('message', handleMessage);
                                            console.log('[SilentRefreshHandler] iframe으로부터 메시지 수신:', event.data);
                                            _event_data1 = event.data, code = _event_data1.code, _$error = _event_data1.error, errorDescription = _event_data1.errorDescription;
                                            if (_$error) {
                                                console.error("[SilentRefreshHandler] Silent refresh failed in iframe: ".concat(_$error, " - ").concat(errorDescription));
                                                cleanupSilentRefreshPKCE();
                                                silentRefreshPromise === null || silentRefreshPromise === void 0 ? void 0 : silentRefreshPromise.resolve({
                                                    success: false,
                                                    error: _$error
                                                });
                                                silentRefreshPromise = null;
                                                return [
                                                    2
                                                ];
                                            }
                                            if (!code) return [
                                                3,
                                                10
                                            ];
                                            console.log("[SilentRefreshHandler] 인가 코드 수신: ".concat(code));
                                            result = {
                                                success: false
                                            };
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                7,
                                                8,
                                                9
                                            ]);
                                            storedVerifier = sessionStorage.getItem(PKCE_CODE_VERIFIER_KEY);
                                            if (!storedVerifier) {
                                                throw new Error('세션 스토리지에서 Code verifier를 찾을 수 없습니다.');
                                            }
                                            tokenParams = new URLSearchParams();
                                            tokenParams.append('grant_type', 'authorization_code');
                                            tokenParams.append('code', code);
                                            tokenParams.append('redirect_uri', SILENT_REDIRECT_URI);
                                            tokenParams.append('client_id', clientId);
                                            tokenParams.append('code_verifier', storedVerifier);
                                            console.log('[SilentRefreshHandler] 토큰 요청 시작:', TOKEN_ENDPOINT);
                                            // DPoP 지원 확인
                                            dpopSupported = isDPoPSupported();
                                            console.log('[SilentRefreshHandler] DPoP supported:', dpopSupported);
                                            // DPoP 헤더 생성 (선택적)
                                            headers = {
                                                'Content-Type': 'application/x-www-form-urlencoded'
                                            };
                                            if (!dpopSupported) return [
                                                3,
                                                5
                                            ];
                                            _state.label = 2;
                                        case 2:
                                            _state.trys.push([
                                                2,
                                                4,
                                                ,
                                                5
                                            ]);
                                            return [
                                                4,
                                                createDPoPHeaders('POST', TOKEN_ENDPOINT, undefined, headers)
                                            ];
                                        case 3:
                                            headers = _state.sent();
                                            console.log('[SilentRefreshHandler] DPoP header added');
                                            return [
                                                3,
                                                5
                                            ];
                                        case 4:
                                            error = _state.sent();
                                            console.warn('[SilentRefreshHandler] DPoP header creation failed:', error);
                                            return [
                                                3,
                                                5
                                            ];
                                        case 5:
                                            return [
                                                4,
                                                axios.post(TOKEN_ENDPOINT, tokenParams, {
                                                    headers: headers
                                                })
                                            ];
                                        case 6:
                                            tokenResponse = _state.sent();
                                            console.log('[SilentRefreshHandler] 토큰 응답 수신:', tokenResponse.data);
                                            _tokenResponse_data = tokenResponse.data, access_token = _tokenResponse_data.access_token, refresh_token = _tokenResponse_data.refresh_token, expires_in = _tokenResponse_data.expires_in, token_type = _tokenResponse_data.token_type;
                                            if (!access_token) {
                                                throw new Error('토큰 응답에 access_token이 없습니다.');
                                            }
                                            // 성공 시 결과 설정
                                            result = {
                                                success: true,
                                                accessToken: access_token,
                                                refreshToken: refresh_token,
                                                expiresIn: expires_in,
                                                tokenType: token_type
                                            };
                                            console.log('[SilentRefreshHandler] PKCE Silent refresh 성공.');
                                            return [
                                                3,
                                                9
                                            ];
                                        case 7:
                                            tokenError = _state.sent();
                                            console.error('[SilentRefreshHandler] 토큰 교환 실패:', tokenError);
                                            if (axios.isAxiosError(tokenError)) {
                                                ;
                                                console.error('[SilentRefreshHandler] 토큰 교환 오류 응답:', (_tokenError_response = tokenError.response) === null || _tokenError_response === void 0 ? void 0 : _tokenError_response.data);
                                            }
                                            result = {
                                                success: false
                                            };
                                            return [
                                                3,
                                                9
                                            ];
                                        case 8:
                                            console.log('[SilentRefreshHandler] handleMessage finally: Resolving promise first...');
                                            silentRefreshPromise === null || silentRefreshPromise === void 0 ? void 0 : silentRefreshPromise.resolve(result);
                                            cleanupSilentRefreshPKCE();
                                            return [
                                                7
                                            ];
                                        case 9:
                                            return [
                                                3,
                                                11
                                            ];
                                        case 10:
                                            console.warn('[SilentRefreshHandler] iframe으로부터 code 또는 error를 받지 못함.');
                                            failResult = {
                                                success: false
                                            };
                                            silentRefreshPromise === null || silentRefreshPromise === void 0 ? void 0 : silentRefreshPromise.resolve(failResult);
                                            cleanupSilentRefreshPKCE();
                                            _state.label = 11;
                                        case 11:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function handleMessage(event) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        window.addEventListener('message', handleMessage);
                        // --- Timeout ---
                        silentRefreshTimeout = setTimeout(function() {
                            console.warn('[SilentRefreshHandler] PKCE Silent refresh timed out.');
                            window.removeEventListener('message', handleMessage);
                            var timeoutResult = {
                                success: false,
                                error: 'timeout'
                            };
                            silentRefreshPromise === null || silentRefreshPromise === void 0 ? void 0 : silentRefreshPromise.resolve(timeoutResult);
                            cleanupSilentRefreshPKCE();
                            silentRefreshTimeout = null;
                        }, 10000); // 타임아웃 10초
                    }).catch(function(pkceError) {
                        console.error('[SilentRefreshHandler] Failed to generate PKCE challenge:', pkceError);
                        cleanupSilentRefreshPKCE();
                        reject(pkceError);
                        silentRefreshPromise = null;
                    });
                })
            ];
        });
    });
    return function handleSilentRefreshPKCE(authServerUrl, silentRedirectUri) {
        return _ref.apply(this, arguments);
    };
}();
